/* eslint-disable no-restricted-globals */
import React, { useState, useEffect } from 'react';
import { View, ViewFilters } from '@uncinc/react-drupal-core';
import config from 'react-global-configuration';
import qs from 'query-string';
import className from 'classnames';
import i18next from '../../../../config/i18next';

import ApiAutocomplete from '../../../../components/ApiAutocomplete';
import {
  Container,
  Select,
  Form,
  Button,
} from '../../../../components';

import './style.scss';
import { formatDate, getRelativeDate } from '../../../../helpers/dates';

const ViewFilterElementCustom = (props) => {
  const { filter, onChange, onReset, defaultValues } = props;
  const API_URL = config.get('API_URL');
  const options = [];
  let defaultValue = null;
  const operatorBetween = 'between';
  switch (filter.get('plugin_id')) {
    case 'datetime':
      options.push({ label: '- Geen voorkeur -' });
      // If the filter uses a between operator, we take the min/max values and use that.
      // Otherwise we use the hardcoded setup, to be backwards compatible.
      if (filter.get('operator') === operatorBetween) {
        // This regex only allows numbers.
        /* eslint prefer-regex-literals: 0*/
        const reg = new RegExp('^\\d+$');
        // In case the regex is true, that means a year has been input, so we have to rewrite the comparison.
        if (reg.test(filter.getIn(['value', 'min'])) === true) {
          for (let year = formatDate(getRelativeDate(new Date(), filter.getIn(['value', 'max'])), 'yyyy'); year >= formatDate(filter.getIn(['value', 'min']), 'yyyy'); year--) {
            options.push({ value: year, label: year });
          }
          // Else use the relative time.
        } else {
          for (let year = formatDate(getRelativeDate(new Date(), filter.getIn(['value', 'max'])), 'yyyy'); year >= formatDate(getRelativeDate(new Date(), filter.getIn(['value', 'min'])), 'yyyy'); year--) {
            options.push({ value: year, label: year });
          }
        }
      } else {
        for (let year = new Date().getFullYear(); year >= 2015; year--) {
          options.push({ value: year, label: year });
        }
      }

      if (defaultValues[filter.get('field')]) {
        defaultValue = { value: defaultValues[filter.get('field')], label: `${defaultValues[filter.get('field')]}` };
      } else {
        defaultValue = options[0];
      }

      return (
        <div className="Form__element" key={filter.get('field')}>
          <label htmlFor={filter.get('field')}>{filter.getIn(['expose', 'label'])}</label>
          <Select
            name={filter.get('field')}
            id={filter.get('field')}
            isSearchable={false}
            handleChange={(option) => {
              if (!option.value) {
                onReset(filter.get('field'));
              } else {
                onChange(filter.get('field'), option.value);
              }
            }}
            options={options}
            defaultValue={defaultValue}
          />
        </div>
      );

    case 'taxonomy_index_tid_depth':
    case 'taxonomy_index_tid':
      options.push({ label: '- Geen voorkeur -' });
      if (filter.get('options')) {
        filter.get('options').valueSeq().forEach((item) => {
          const value = item.get('value');
          const label = item.get('label');
          options.push({ value, label });

          if (item.get('children')) {
            item.get('children').map((subitem) => {
              const subvalue = subitem.get('value');
              const sublabel = subitem.get('label');
              options.push({ value: subvalue, label: <div><span className="indent" />{sublabel}</div> });
            });
          }
        });
      }

      if (defaultValues[filter.get('field')]) {
        const findOption = (items) => {
          return items.value === defaultValues[filter.get('field')];
        };

        defaultValue = options.find(findOption);
      } else {
        defaultValue = options[0];
      }

      return (
        <div className="Form__element" key={filter.get('field')}>
          <label htmlFor={filter.get('field')}>{filter.getIn(['expose', 'label'], '')}</label>
          <Select
            name={filter.get('field')}
            options={options}
            id={filter.get('field')}
            isSearchable={false}
            handleChange={(option) => {
              if (!option.value) {
                onReset(filter.get('field'));
              } else {
                onChange(filter.get('field'), [option.value]);
              }
            }}
            defaultValue={defaultValue}
          />
        </div>
      );

    case 'string':
      if (defaultValues[filter.get('field')]) {
        defaultValue = defaultValues[filter.get('field')];
      }

      return (
        <div className="Form__element" key={filter.get('field')}>
          <label htmlFor={filter.get('field')}>{filter.getIn(['expose', 'label'])}</label>
          <ApiAutocomplete
            name={filter.get('field')}
            id={filter.get('field')}
            endpoint={`${API_URL}/api/autocomplete`}
            placeholder="Zoek op plaatsnaam"
            defaultValue={defaultValue}
            onSelectItem={(item) => {
              onChange(filter.get('field'), item.name);
            }}
            renderItem={(item, active) => {
              const classes = className({
                active: active,
              });
              return (
                <div className={classes}>
                  {item.name}
                  {item.type === 'gemeente'
                    && <> (Gemeente)</>}
                </div>
              );
            }}
          />
        </div>
      );

    default:
      return (
        <div>
          Filter Element: {filter.get('plugin_id')}
        </div>
      );
  }
};


const ProjectsAll = (props) => {
  const { id, withHeader } = props;
  const initialValues = qs.parse(location?.search ?? '', { ignoreQueryPrefix: true });
  const [filters, setFilters] = useState(initialValues);
  const [appliedFilters, setAppliedFilters] = useState(filters);

  useEffect(() => {
    const submitFilters = () => {
      if (filters && initialValues) {
        const newQuery = qs.stringify({ ...filters }, {
          skipNull: true,
        });

        const splitUrl = window.location.href.split('?')[0];

        if (!newQuery) {
          window.history.pushState('', '', splitUrl);
        } else {
          window.history.pushState('', '', `?${newQuery}`);
        }
      }

      const dateValue = filters['field_date_value'] ? ({
        min: `${filters['field_date_value']}-01-01`,
        max: `${filters['field_date_value']}-12-31`,
      }) : ({
        min: '',
        max: '',
      });

      setAppliedFilters({
        field_area_target_id: [filters['field_area_target_id']],
        field_date_value: dateValue,
        field_theme_target_id: [filters['field_theme_target_id']],
        term_node_tid_depth: filters['term_node_tid_depth'],
        field_target_audience_target_id: filters['field_target_audience_target_id'],
        field_fonds_op_naam_type_target_id: filters['field_fonds_op_naam_type_target_id'],
      });
    };
    submitFilters();

  }, [filters]);

  const resetFilter = (field) => {
    delete filters[field];
    setFilters({ ...filters });
  };

  const updateFilter = (field, value) => {
    setFilters({
      ...filters,
      [field]: value,
    });
  };

  return (
    <div id={props.paragraphKey} className="ViewWithFilters">
      <Container>
        {withHeader ? (
          <div className="ViewWithFilters__form ViewWithFilters__form__with-header">
            <Form>
              <ViewFilters
                viewId={id}
                display="block_1"
                onFilterUpdate={(field, value) => { updateFilter(field, value); }}
                onResetFilter={(field) => { resetFilter(field); }}
                onRender={(renderProps) => {
                  return <ViewFilterElementCustom {...renderProps} defaultValues={initialValues} />;
                }}
              />
            </Form>
            <div className="ViewWithFilters__form__with-header__button">
              <Button
                secondary
                withIcon
                icon="marker"
                className="moving-arrow"
                href="/landkaart"
              >
                {i18next.t('to_the_map')}
              </Button>
            </div>
          </div>
        ) : (
          <div className="ViewWithFilters__form">
            <Form>
              <ViewFilters
                viewId={id}
                display="default"
                onFilterUpdate={(field, value, type) => { updateFilter(field, value, type); }}
                onResetFilter={(field) => { resetFilter(field); }}
                onRender={(renderProps) => {
                  return <ViewFilterElementCustom {...renderProps} defaultValues={initialValues} />;
                }}
              />
            </Form>
          </div>
        )}
      </Container>
      <View {...props} filters={appliedFilters} />
    </div>
  );
};

export default ProjectsAll;
